<template>
  <div class="container-create">
    <Navigation />
    <Form />
  </div>
</template>

<script>
import Form from './Form'
import Navigation from './Nav'
export default {
  components: { Form, Navigation },
  async mounted() {
    await this.$store.dispatch(
      'packingListTemplate/clearCurrentPackingListTemplate'
    )
  },
}
</script>

<style lang='scss' scoped>
.container-create {
  padding: 0px 30px;
  margin: 0 auto;
  margin-top: 20px;
}
</style>